var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"dashboard"}},[_c('TitleComponent'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card mt-3"},[_c('div',{staticClass:"card-body text-center"},[_c('h4',{staticStyle:{"font-size":"30px"}},[_vm._v("Selamat datang di Dashboard")]),_c('p',{staticStyle:{"font-size":"15px"}},[_vm._v("Aplikasi upload gambar produk")])])])
}]

export { render, staticRenderFns }